


import React, { useState, useRef, useEffect } from "react";

const Registration = () => {
    // Initial rows configuration with proper initial values
    const initialRowsConfig = [
        // COMPANY DETAILS SECTION
        {
            key: "Company Name",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Company Details",
            apiField: "companyName",
            isRequired: true
        },
        {
            key: "Company Type",
            value: "",
            isEditing: false,
            status: "Pending",
            isDropdown: true,
            options: ["PROPRIETORSHIP", "PARTNERSHIP", "LLP", "PRIVATE_LIMITED"],
            section: "Company Details",
            apiField: "businessType",
            isRequired: true
        },
        {
            key: "Company PAN",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Company Details",
            apiField: "companyPan",
            isRequired: true
        },
        {
            key: "Company GST",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Company Details",
            apiField: "gstin",
            isRequired: false
        },
        {
            key: "CIN (For Companies)",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Company Details",
            apiField: "cin",
            isRequired: false
        },
        {
            key: "Registered Address",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Company Details",
            apiField: "registeredAddress",
            isRequired: true
        },
        {
            key: "City",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Company Details",
            apiField: "city",
            isRequired: true
        },
        {
            key: "State",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Company Details",
            apiField: "state",
            isRequired: true
        },
        {
            key: "Pincode",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Company Details",
            apiField: "pincode",
            isRequired: true
        },

        // COMPANY DOCUMENTS SECTION
        {
            key: "Incorporation Certificate",
            value: "",
            document: null,
            isEditing: false,
            isUpload: true,
            status: "Not Uploaded",
            section: "Company Documents",
            apiField: "incorporationCertificate",
            isDocument: true,
            isRequired: false
        },
        {
            key: "GST Certificate",
            value: "",
            document: null,
            isEditing: false,
            isUpload: true,
            status: "Not Uploaded",
            section: "Company Documents",
            apiField: "gstCertificate",
            isDocument: true,
            isRequired: false
        },
        {
            key: "Trade License",
            value: "",
            document: null,
            isEditing: false,
            isUpload: true,
            status: "Not Uploaded",
            section: "Company Documents",
            apiField: "tradeLicense",
            isDocument: true,
            isRequired: false
        },

        {
            key: "Wallet Type",
            value: "",
            isEditing: false,
            status: "Pending",
            isDropdown: true,
            options: ["POSTPAID", "PREPAID"],
            section: "Wallet Details",
            apiField: "walletType",
            isRequired: true
        },

        // OWNER DETAILS SECTION
        {
            key: "Owner Full Name",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Owner Details",
            apiField: "ownerFullName",
            isRequired: true
        },
        {
            key: "Owner Date of Birth",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Owner Details",
            apiField: "ownerDob",
            isRequired: true
        },
        {
            key: "Owner PAN",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Owner Details",
            apiField: "ownerPan",
            isRequired: true
        },
        {
            key: "Owner Aadhaar",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Owner Details",
            apiField: "ownerAadhaar",
            isRequired: true
        },
        {
            key: "Owner Mobile",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Owner Details",
            apiField: "ownerMobile",
            isRequired: true
        },
        {
            key: "Owner Email",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Owner Details",
            apiField: "ownerEmail",
            isRequired: true
        },
        {
            key: "Owner Address",
            value: "",
            isEditing: false,
            status: "Pending",
            section: "Owner Details",
            apiField: "ownerAddress",
            isRequired: true
        },

        // OWNER DOCUMENTS SECTION
        {
            key: "Owner PAN Document",
            value: "",
            document: null,
            isEditing: false,
            isUpload: true,
            status: "Not Uploaded",
            section: "Owner Documents",
            apiField: "ownerPanDocument",
            isDocument: true,
            isRequired: false
        },
        {
            key: "Owner Aadhaar Document",
            value: "",
            document: null,
            isEditing: false,
            isUpload: true,
            status: "Not Uploaded",
            section: "Owner Documents",
            apiField: "ownerAadhaarDocument",
            isDocument: true,
            isRequired: false
        },
        {
            key: "Owner Image",
            value: "",
            document: null,
            isEditing: false,
            isUpload: true,
            status: "Not Uploaded",
            section: "Owner Documents",
            apiField: "ownerSelfie",
            isDocument: true,
            isRequired: false
        },
    ];

    const [rows, setRows] = useState(initialRowsConfig);
    const [loading, setLoading] = useState(false);
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [verificationStatus, setVerificationStatus] = useState(null);
    const [existingData, setExistingData] = useState(null);
    const [authError, setAuthError] = useState("");

    const fileInputRefs = useRef({});
    const isImageUrl = (url = "") => {
        if (!url) return false;
        const clean = url.split("?")[0].toLowerCase();
        return clean.endsWith(".png") || clean.endsWith(".jpg") || clean.endsWith(".jpeg") || clean.endsWith(".webp");
    };



    // Get authentication token and user ID from localStorage
    const getAuthData = () => {
        try {
            const token = localStorage.getItem("authToken") || "";
            const professionalUserId = localStorage.getItem("professionalUserId");


            return {
                token: token,
                userId: professionalUserId
            };
        } catch (error) {
            console.error("Error getting auth data:", error);
            return { token: null, professionalUserId: null };
        }
    };

    // Fetch existing company verification data
    const fetchCompanyVerificationData = async () => {
        const token = localStorage.getItem("authToken");
        const professionalUserId = localStorage.getItem("professionalUserId");

        if (!token || !professionalUserId) {
            setAuthError("Please login first to access company verification");
            setIsLoadingData(false);
            return;
        }

        try {
            setIsLoadingData(true);

            const response = await fetch(
                `https://backend.maamaas.com/subscription/api/user/company/verification/${professionalUserId}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            /* ---------- NO DATA ---------- */
            if (response.status === 404) {


                setExistingData(null);
                setVerificationStatus(null);

                setRows(prev =>
                    prev.map(row => ({
                        ...row,
                        value: "",
                        document: null,
                        status: row.isUpload ? "Not Uploaded" : "Pending",
                        isEditing: false
                    }))
                );
                return;
            }

            if (!response.ok) {
                const errorText = await response.text();

                return;
            }

            const data = await response.json();



            setExistingData(data);
            setVerificationStatus(data.verificationStatus || null);

            /* ---------- MAP DATA TO ROWS ---------- */
            setRows(prev =>
                prev.map(row => {
                    if (!row.apiField) return row;

                    const apiValue = data[row.apiField];

                    // TEXT FIELDS
                    if (!row.isUpload) {
                        return {
                            ...row,
                            value: apiValue ?? "",
                            status: apiValue ? "Submitted" : "Pending",
                            isEditing: false
                        };
                    }

                    // DOCUMENT FIELDS
                    return {
                        ...row,
                        value: apiValue ? apiValue.split("/").pop() : "",
                        document: apiValue
                            ? { name: apiValue.split("/").pop(), url: apiValue }
                            : null,
                        status: apiValue ? "Uploaded" : "Not Uploaded",
                        isEditing: false
                    };
                })
            );

        } catch (error) {
            console.error("❌ Error fetching company verification data:", error);

            setAuthError(error.message);
        } finally {
            setIsLoadingData(false);
        }
    };

    // Trigger file input click
    const handleUploadClick = (index) => {
        if (!canEdit) return;

        if (fileInputRefs.current[index]) {
            fileInputRefs.current[index].click();
        }
    };

    // Prepare form data for submission - MULTIPART/FORM-DATA FORMAT
    const prepareFormData = () => {
        const formData = new FormData();

        const professionalUserId = localStorage.getItem("professionalUserId");

        const companyData = {
            userId: Number(professionalUserId),
            verificationStatus: "PENDING",
            rejectionReason: ""
        };

        // TEXT / DROPDOWN VALUES
        rows.forEach(row => {
            if (!row.isUpload && row.apiField && row.value?.trim()) {
                companyData[row.apiField] = row.value.trim();
            }
        });



        // 🔹 JSON PART
        formData.append(
            "companyData",
            new Blob([JSON.stringify(companyData)], {
                type: "application/json",
            })
        );

        // 🔹 FILE PARTS (ONLY NEW FILES)
        rows.forEach(row => {
            if (
                row.isUpload &&
                row.apiField &&
                row.document instanceof File
            ) {

                formData.append(row.apiField, row.document);
            }
        });

        return formData;
    };




    const handleUpdate = async () => {
        const token = localStorage.getItem("authToken");

        // 🔴 verification id MUST exist
        if (!token || !existingData?.id) {
            alert("❌ Missing verification ID or login");
            return;
        }

        setLoading(true);

        try {
            const formData = prepareFormData();

            /* 🔍 DEBUG: WHAT IS BEING SENT */

            for (let pair of formData.entries()) {
                //////console.log(pair[0], pair[1]);
            }

            const response = await fetch(
                `https://backend.maamaas.com/subscription/api/company/verification/${existingData.id}`,
                {
                    method: "PUT",                     // ✅ PUT API
                    headers: {
                        Authorization: `Bearer ${token}` // ❌ DO NOT set Content-Type
                    },
                    body: formData
                }
            );

            /* 🔥 FULL BACKEND RESPONSE */

            const rawText = await response.text();




            // alert("✅ Company verification updated successfully");

            setVerificationStatus("PENDING");
            fetchCompanyVerificationData();

        } catch (error) {
            console.error("❌ Update error:", error);
            alert("❌ Error: " + error.message);
        } finally {
            setLoading(false);
        }
    };


    // Handle form submission (POST API) - MULTIPART/FORM-DATA
    const handleSubmit = async (e) => {
        e.preventDefault();

        const token = localStorage.getItem("authToken");

        if (!token) {
            alert("❌ Please login first");
            return;
        }

        setLoading(true);
        setAuthError("");

        try {
            const formData = prepareFormData();


            for (let pair of formData.entries()) {
                //////console.log(pair[0], pair[1]);
            }

            const response = await fetch(
                "https://backend.maamaas.com/subscription/api/user/company/verification",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`, // ✅ ONLY auth header
                    },
                    body: formData,
                }
            );

            // ✅ SAFE RESPONSE PARSING
            let responseData;
            const contentType = response.headers.get("content-type");

            if (contentType && contentType.includes("application/json")) {
                responseData = await response.json();
            } else {
                responseData = await response.text();
            }

            if (!response.ok) {
                throw new Error(
                    typeof responseData === "string"
                        ? responseData
                        : responseData?.message || "Submission failed"
                );
            }

            // ✅ SUCCESS


            setVerificationStatus("PENDING");

            // Update UI status
            setRows(prev =>
                prev.map(row => ({
                    ...row,
                    status: row.document
                        ? "Uploaded"
                        : row.value
                            ? "Submitted"
                            : row.status,
                    isEditing: false,
                }))
            );

            // 🔄 Refresh data
            setTimeout(() => {
                fetchCompanyVerificationData();
            }, 1000);

        } catch (error) {
            console.error("❌ Submission error:", error);
            alert("❌ Error: " + error.message);
            setAuthError(error.message);
        } finally {
            setLoading(false);
        }
    };




    useEffect(() => {
        fetchCompanyVerificationData();
    }, []);

    // Handle edit button click
    const handleEdit = (index) => {
        if (!canEdit) return;

        setRows(prevRows =>
            prevRows.map((r, i) => ({
                ...r,
                isEditing: i === index
            }))
        );
    };

    // Handle save button click
    const handleSave = (index) => {
        setRows(prevRows =>
            prevRows.map((r, i) => ({
                ...r,
                isEditing: i === index ? false : r.isEditing,
                status: i === index && r.value ?
                    (r.isDocument ? r.status : "Submitted") : r.status
            }))
        );
    };

    // Handle file upload
    const handleFileChange = (e, index) => {
        if (!canEdit) return;

        const file = e.target.files[0];
        if (file) {
            setRows(prevRows =>
                prevRows.map((row, i) => {
                    if (i === index) {
                        return {
                            ...row,
                            document: file,
                            value: file.name,
                            status: "Uploaded"
                        };
                    }
                    return row;
                })
            );
        }

        // Reset file input
        if (fileInputRefs.current[index]) {
            fileInputRefs.current[index].value = null;
        }
    };





    // Get status color based on status value
    const getStatusColor = (status) => {
        if (!status) return "#9e9e9e";

        const statusUpper = status.toUpperCase();
        switch (statusUpper) {
            case "VERIFIED":
                return "#ee6521";
            case "UPLOADED":
            case "SUBMITTED":
            case "PROVIDED":
                return "#ee6521";
            case "REJECTED":
                return "#f44336";
            case "NOT UPLOADED":
                return "#ff9800";
            case "PENDING":
                return "#ff9800";
            default:
                return "#9e9e9e";
        }
    };

    // Check if user can edit
    const canEdit = (verificationStatus !== "VERIFIED" && verificationStatus !== "PENDING") || verificationStatus === null;

    // Inline Styles
    const containerStyle = {
        marginTop: "80px",
         padding: "5px",
        fontFamily: "Arial, sans-serif",
        maxWidth: "1350px",
        marginLeft: "auto",
        marginRight: "auto",
        minHeight: "100vh"
    };

    const headerStyle = {
        textAlign: "center",
        marginBottom: "30px",
        color: "#333"
    };

    const tableContainerStyle = {
        overflow: "auto",
        border: "1px solid #ddd",
        height: "100vh",
        scrollbarWidth: "none",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        backgroundColor: "white"
    };

    const tableStyle = {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "none",
        tableLayout: "fixed"
    };

    const tableHeaderStyle = {
        border: "1px solid #ddd",
        padding: "14px",
        backgroundColor: "#ee6521",
        color: "white",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "15px",
        position: "sticky",
        top: 0,
        zIndex: 10
    };

    const tableCellStyle = {
        border: "1px solid #ddd",
        padding: "12px",
        verticalAlign: "top",
        textAlign: "center",
        fontSize: "14px",
    };

    const evenRowStyle = { backgroundColor: "#f9f9f9" };
    const oddRowStyle = { backgroundColor: "#ffffff" };

    const inputStyle = {
        width: "100%",
        border: "1px solid #ccc",
        padding: "8px",
        borderRadius: "4px",
        fontSize: "14px",
        boxSizing: "border-box",
        minHeight: "36px"
    };

    const buttonStyle = {
        backgroundColor: "#2196f3",
        color: "white",
        padding: "6px 12px",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        fontSize: "12px",
        fontWeight: "bold",
        transition: "background-color 0.3s",
        minWidth: "60px"
    };

    const editButtonStyle = {
        ...buttonStyle,
        backgroundColor: "#ff9800",
        opacity: canEdit ? 1 : 0.5
    };

    const saveButtonStyle = {
        ...buttonStyle,
        backgroundColor: "#4caf50",
        opacity: canEdit ? 1 : 0.5
    };

    const uploadButtonStyle = {
        ...buttonStyle,
        backgroundColor: "#2196f3",
        margin: "5px 0",
        padding: "6px 12px",
        fontSize: "12px",
        opacity: canEdit ? 1 : 0.5
    };

    const submitButtonStyle = {
        backgroundColor: "#673ab7",
        color: "white",
        padding: "14px 28px",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: "bold",
        marginTop: "30px",
        width: "250px",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
    };

    const fileInfoStyle = {
        marginTop: "5px",
        fontSize: "11px",
        wordBreak: "break-all",
        textAlign: "center",
        color: "#666",
        fontStyle: "italic"
    };

    const statusBannerStyle = (status) => ({
        padding: "15px",
        marginBottom: "20px",
        borderRadius: "8px",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "16px",
        backgroundColor: `${getStatusColor(status)}20`,
        border: `2px solid ${getStatusColor(status)}`,
        color: getStatusColor(status)
    });

    const errorStyle = {
        padding: "15px",
        marginBottom: "20px",
        borderRadius: "8px",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "16px",
        backgroundColor: "#ffebee",
        border: `2px solid #f44336`,
        color: "#d32f2f"
    };

    const loadingStyle = {
        textAlign: "center",
        padding: "40px",
        color: "#666",
        fontSize: "16px"
    };

    return (
        <div style={containerStyle}>
            {/* Header */}


            {isLoadingData ? (
                <div style={loadingStyle}>
                    Loading company verification data...
                </div>
            ) : (
                <>
                    {/* Authentication Error */}


                    <form onSubmit={handleSubmit}>
                        {/* Single Table for All Data */}
                        <div style={{ marginBottom: "30px" }}>
                            <div style={tableContainerStyle}>
                                <table
                                    className="tably"
                                    style={{ marginTop: "0px", marginBottom: "0px" }}
                                >

                                    <thead>
                                        <tr>
                                            <th style={{ ...tableHeaderStyle, width: "180px" }}>Field</th>
                                            <th style={{ ...tableHeaderStyle, width: "350px" }}>Value</th>
                                            <th style={{ ...tableHeaderStyle, width: "150px" }}>Document</th>
                                            <th style={{ ...tableHeaderStyle, width: "100px" }}>Status</th>
                                            <th style={{ ...tableHeaderStyle, width: "100px" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr key={row.key} style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
                                                {/* Field Column */}
                                                <td style={tableCellStyle}>
                                                    <strong>{row.key}</strong>
                                                    {row.isRequired && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                                </td>

                                                {/* Value Column */}
                                                {/* Value Column */}
                                                {/* Value Column */}
                                                <td
                                                    style={{
                                                        ...tableCellStyle,
                                                        textAlign: "left",
                                                        wordBreak: "break-word",
                                                    }}
                                                >
                                                    {row.isEditing ? (
                                                        /* 🔹 EDIT MODE */
                                                        row.isDropdown ? (
                                                            /* ✅ DROPDOWN */
                                                            <select
                                                                value={row.value || ""}
                                                                onChange={(e) =>
                                                                    setRows(prev =>
                                                                        prev.map((r, i) =>
                                                                            i === index ? { ...r, value: e.target.value } : r
                                                                        )
                                                                    )
                                                                }
                                                                style={inputStyle}
                                                                disabled={!canEdit}
                                                            >
                                                                <option value="">-- Select --</option>
                                                                {row.options?.map(opt => (
                                                                    <option key={opt} value={opt}>
                                                                        {opt.replace("_", " ")}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        ) : row.key === "Owner Date of Birth" ? (
                                                            /* 📅 DATE */
                                                            <input
                                                                type="date"
                                                                value={row.value || ""}
                                                                onChange={(e) =>
                                                                    setRows(prev =>
                                                                        prev.map((r, i) =>
                                                                            i === index ? { ...r, value: e.target.value } : r
                                                                        )
                                                                    )
                                                                }
                                                                style={inputStyle}
                                                                disabled={!canEdit}
                                                            />
                                                        ) : (
                                                            /* 📝 TEXT */
                                                            <input
                                                                type="text"
                                                                value={row.value || ""}
                                                                onChange={(e) =>
                                                                    setRows(prev =>
                                                                        prev.map((r, i) =>
                                                                            i === index ? { ...r, value: e.target.value } : r
                                                                        )
                                                                    )
                                                                }
                                                                style={inputStyle}
                                                                disabled={!canEdit}
                                                            />
                                                        )
                                                    ) : (
                                                        /* 🔹 VIEW MODE */
                                                        <>
                                                            {row.isUpload && row.document?.url && isImageUrl(row.document.url) ? (
                                                                <img
                                                                    src={row.document.url}
                                                                    alt={row.key}
                                                                    style={{
                                                                        width: "120px",
                                                                        height: "120px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "8px",
                                                                        border: "1px solid #ccc",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={() => window.open(row.document.url, "_blank")}
                                                                />
                                                            ) : row.isUpload && row.document?.url ? (
                                                                <a
                                                                    href={row.document.url}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ color: "#1976d2", fontSize: "13px" }}
                                                                >
                                                                    View File
                                                                </a>
                                                            ) : (
                                                                <div style={{ minHeight: "36px", display: "flex", alignItems: "center" }}>
                                                                    {row.value || <em style={{ color: "#999" }}>Not specified</em>}
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </td>



                                                {/* Document Column */}
                                                <td style={tableCellStyle}>
                                                    {row.isUpload ? (
                                                        <div style={{ textAlign: "center" }}>
                                                            {/* IMAGE / FILE PREVIEW */}
                                                            {row.document?.url && (
                                                                <>
                                                                    {/* IMAGE */}
                                                                    {row.document.url.match(/\.(jpg|jpeg|png|webp)$/i) ? (
                                                                        <img
                                                                            src={row.document.url}
                                                                            alt="document"
                                                                            style={{
                                                                                width: "90px",
                                                                                height: "90px",
                                                                                objectFit: "cover",
                                                                                borderRadius: "6px",
                                                                                marginBottom: "6px",
                                                                                border: "1px solid #ccc",
                                                                                cursor: "pointer"
                                                                            }}
                                                                            onClick={() =>
                                                                                window.open(row.document.url, "_blank")
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        /* PDF / DOC */
                                                                        <a
                                                                            href={row.document.url}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={{
                                                                                color: "#1976d2",
                                                                                fontSize: "12px",
                                                                                display: "block",
                                                                                marginBottom: "6px"
                                                                            }}
                                                                        >
                                                                            View File
                                                                        </a>
                                                                    )}
                                                                </>
                                                            )}

                                                            {/* UPLOAD BUTTON */}
                                                            <button
                                                                type="button"
                                                                style={uploadButtonStyle}
                                                                onClick={() => handleUploadClick(index)}
                                                                disabled={!canEdit}
                                                            >
                                                                {row.document ? "Change File" : "Upload File"}
                                                            </button>

                                                            <input
                                                                type="file"
                                                                ref={(el) => (fileInputRefs.current[index] = el)}
                                                                style={{ display: "none" }}
                                                                onChange={(e) => handleFileChange(e, index)}
                                                                disabled={!canEdit}
                                                            />
                                                        </div>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>


                                                {/* Status Column */}
                                                <td style={tableCellStyle}>
                                                    <span
                                                        style={{
                                                            color: getStatusColor(row.status),
                                                            fontWeight: "bold",
                                                            fontSize: "12px",
                                                            padding: "4px 8px",
                                                            borderRadius: "12px",
                                                            backgroundColor: `${getStatusColor(row.status)}15`
                                                        }}
                                                    >
                                                        {row.status}
                                                    </span>
                                                </td>

                                                {/* Actions Column */}
                                                <td style={tableCellStyle}>
                                                    {row.isEditing ? (
                                                        <button
                                                            type="button"
                                                            style={saveButtonStyle}
                                                            onClick={() => handleSave(index)}
                                                            disabled={!canEdit}
                                                        >
                                                            Save
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            style={editButtonStyle}
                                                            onClick={() => handleEdit(index)}
                                                            disabled={!canEdit}
                                                        >
                                                            Edit
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div style={{ textAlign: "center", marginTop: "40px" }}>

                            {/* ✅ UPDATE BUTTON (REJECTED) */}
                            {verificationStatus === "REJECTED" && (
                                <button
                                    type="button"
                                    onClick={handleUpdate}
                                    style={{
                                        ...submitButtonStyle,
                                        backgroundColor: "#f44336",
                                        opacity: loading ? 0.7 : 1
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? "Updating..." : "Update & Resubmit"}
                                </button>
                            )}

                            {/* ✅ SUBMIT BUTTON (FIRST TIME) */}
                            {(verificationStatus === null) && (
                                <button
                                    type="submit"
                                    style={{ ...submitButtonStyle, opacity: loading ? 0.7 : 1 }}
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Submit Registration"}
                                </button>
                            )}

                            {/* INFO MESSAGES */}
                            {verificationStatus === "PENDING" && (
                                <div style={{ marginTop: "10px", color: "#ff9800", fontSize: "14px" }}>
                                    Your submission is under review. You cannot make changes while pending.
                                </div>
                            )}

                            {verificationStatus === "REJECTED" && (
                                <div style={{ marginTop: "10px", color: "#f44336", fontSize: "14px" }}>
                                    Your submission was rejected. Please correct the details and update.
                                </div>
                            )}

                        </div>

                    </form>
                </>
            )}
        </div>
    );
};

export default Registration;